import React from 'react';
import { BookType } from '@monorepo/shared/src/graph/schema-generated-types-educator';
import BookContent from './BooksContent';

const ClassroomBooksContent: React.FC<{ fromRoute?: string }> = ({ fromRoute }) => {
  return <BookContent bookType={BookType.CLASSROOM_BOOK} fromRoute={fromRoute} />;
};

export default ClassroomBooksContent;
